import {html, type TemplateResult} from 'lit';
import type {CategoryInfo} from '../quiz-controller';

/**
 * 次の文字種の提案。正解の自動送りの代わりに、選択肢ボタンと同じ場所に 1 回だけ出す。
 *
 * 選択肢の直下に差し込むと誤タップを誘うので、同じスロットを差し替える。
 * 選択肢ボタンが消えるとフォーカスが body に落ちるので、要素側がこのグループに移す
 * （「追加する」には移さない。誤操作防止）。
 */
export function categorySuggestion(
  next: CategoryInfo,
  onAccept: () => void,
  onLater: () => void
): TemplateResult {
  return html`
    <div
      id="dq-suggestion"
      role="group"
      aria-label="次の文字種の提案"
      tabindex="-1"
      class="mt-8 rounded-xl bg-teal-50 p-5 text-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-700"
    >
      <p class="text-gray-800">
        いま選んでいる文字はよく覚えています。次は
        <strong class="text-teal-800">${next.label} (${next.en})</strong> を足しますか。
      </p>
      <div class="mt-4 flex flex-wrap justify-center gap-3">
        <button
          type="button"
          @click=${onAccept}
          class="px-6 py-3 bg-teal-700 hover:bg-teal-800 text-white font-medium rounded-lg shadow transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-700 focus-visible:ring-offset-2"
        >
          追加する
        </button>
        <button
          type="button"
          @click=${onLater}
          class="px-6 py-3 bg-white border-2 border-teal-600 hover:bg-teal-100 text-teal-800 font-medium rounded-lg shadow-sm transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-700 focus-visible:ring-offset-2"
        >
          あとで
        </button>
      </div>
    </div>
  `;
}
